import { render, staticRenderFns } from "./Checkbox2.vue?vue&type=template&id=201ad07c&lang=pug"
import script from "./Checkbox2.vue?vue&type=script&lang=js"
export * from "./Checkbox2.vue?vue&type=script&lang=js"
import style0 from "./Checkbox2.vue?vue&type=style&index=0&id=201ad07c&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports